import { ReactNode } from 'react';
import Checkbox from '@mui/material/Checkbox';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { fontSize, spacing } from 'presentations/views/styles';
import ErrorText from 'presentations/views/components/atoms/ErrorText';
import { black, gray02 } from 'presentations/views/styles/color';
import Skeleton from 'presentations/views/components/atoms/Skeleton';

interface Props {
  label?: string | ReactNode;
  isChecked?: boolean;
  isDisabled?: boolean;
  value?: string | number;
  defaultValue?: string | number;
  id?: string;
  name?: string;
  onChange?: any;
  onClick?: any;
  isError?: boolean;
  errorText?: string;
  helperText?: string;
  className?: string;
  dataProps?: any;
  color?: 'primary' | 'secondary' | 'default';
  specifyColor?: string;
  isLoading?: boolean;
}

export default function Component(props: Props) {
  const dataProps = props.dataProps || {};
  return (
    <Container specifyColor={props.specifyColor}>
      {props.isLoading ? (
        <SkeletonContainer>
          <Skeleton variant="rectangular" width="20px" height="20px" />
        </SkeletonContainer>
      ) : (
        <Checkbox
          color={props.color || 'primary'}
          className={props.className}
          checked={props.isChecked}
          disabled={props.isDisabled}
          size="small"
          value={props.value}
          defaultValue={props.defaultValue}
          id={props.id}
          name={props.name}
          onChange={props.onChange}
          onClick={props.onClick}
          {...dataProps}
        />
      )}
      {props.label && typeof props.label === 'string' ? (
        <Label isDisabled={props.isDisabled}>{props.label}</Label>
      ) : (
        props.label
      )}
      {props.helperText && <HelperText>{props.helperText}</HelperText>}
      {props.isError && props.errorText && (
        <ErrorText>{props.errorText}</ErrorText>
      )}
    </Container>
  );
}

const Container = styled.div<{
  specifyColor?: string;
}>`
  display: flex;
  align-items: center;

  ${({ specifyColor }) =>
    specifyColor &&
    css`
      & .MuiCheckbox-colorPrimary.Mui-checked {
        color: ${specifyColor};
      }
    `}
`;
const Label = styled.span<{ isDisabled?: boolean }>`
  /* font-size: ${fontSize(12)}; */
  color: ${({ isDisabled }) => (isDisabled ? gray02 : black)};
`;

const HelperText = styled.div`
  font-size: ${fontSize(12)};
  margin-top: ${spacing(4)};
`;

const SkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
`;
